export class EvaluationRatifier {
  constructor(router, bffEvaluationsClient, buefy) {
    this.bffEvaluationsClient = bffEvaluationsClient;
    this.router = router;
    this.buefy = buefy;
  }

  async ratify(manualEvaluationId, parentEvaluationId) {
    try {
      const ratify = await this.bffEvaluationsClient.setRatify(manualEvaluationId);

      if (ratify.data.result === true) {
        await this.router.push({
          name: 'evaluation-detail',
          params: { evaluationId: parentEvaluationId }
        });
      } else {
        this.printMessage(`${ratify.data.message}`);
      }
    } catch (error) {
      this.printMessage(`No se pudo ratificar la evaluación ${error.message}`);
    }
  }

  printMessage(message) {
    this.buefy.toast.open({
      position: 'is-bottom-left',
      message,
      type: 'is-danger',
      duration: 5000
    });
  }
}
